import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlagLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.07312 11.4068C4.07312 11.4068 5.96146 9.5185 9.87354 11.1928C13.7865 12.8671 15.9278 11.4263 15.9278 11.4263V3.42539C15.9278 3.42539 13.7865 4.86617 9.87354 3.19188C5.96146 1.5184 4.07312 3.40674 4.07312 3.40674V17.5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFlagLine;
